// Which creature plays which sound: synth instruments by model, drum pads by name.
import type { Species } from "@eb/shared";

const SYNTH: Record<string, Species> = {
  mono: "woodwump",
  acid: "acidmite",
  poly: "choruspede",
  fm: "operatoad",
  organ: "drawbear",
  drum808: "boomer",
  bass808: "boomer",
  // Acoustic-style models (mirrors engine `SynthModel::species`).
  pluck: "choruspede",
  bowed: "choruspede",
  piano: "operatoad",
  brass: "woodwump",
  flute: "woodwump",
  // Atmos and the newer instruments (rt/textures.rs).
  drone: "choruspede",
  texture: "choruspede",
  choir: "choruspede",
  sparkle: "glimmer",
  sweep: "glimmer",
  impact: "boomer",
  super: "choruspede",
  mallet: "operatoad",
  reed: "woodwump",
};

/** Instrument slots without a known synth model (16 bass, 17 harmony, 18 lead, 20 atmos). */
const INSTRUMENT_FALLBACK: Record<number, Species> = {
  16: "woodwump",
  17: "choruspede",
  18: "operatoad",
  20: "glimmer",
};

const RULES: [RegExp, Species][] = [
  [/kick|bass ?drum/, "thumper"],
  [/snare|rim/, "snapper"],
  [/hat|shaker/, "chirper"],
  [/clap/, "clapper"],
  [/808|sub|bass/, "wobbler"],
  [/pluck|stab|blip|riser|ride|crash|impact/, "glimmer"],
];

export function speciesForSound(name: string, slot: number, synthModel?: string | null): Species {
  if (synthModel && SYNTH[synthModel]) return SYNTH[synthModel];
  const n = name.toLowerCase();
  for (const [re, sp] of RULES) if (re.test(n)) return sp;
  return INSTRUMENT_FALLBACK[slot] ?? "critter";
}
